module.exports = "<svg id=\"i-edit\" viewBox=\"0 0 32 32\" width=\"32\" height=\"32\" fill=\"none\" stroke=\"currentcolor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"6.25%\">\n  <path d=\"M30 7 L25 2 5 22 3 29 10 27 Z M21 6 L26 11 Z M5 22 L10 27 Z\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/svg/edit.svg
// module id = 84
// module chunks = 0